import { useState } from 'react'
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Label,
  RadioGroup,
  RadioGroupItem,
} from '@brent/core-ui/ui'
import { Loader2 } from 'lucide-react'
import type { Question } from '@/services/api/questions'

interface VoteFormProps {
  question: Question
  currentOptionId?: string
  isPending: boolean
  onSubmit: (optionId: string) => void
}

export default function VoteForm({
  question,
  currentOptionId,
  isPending,
  onSubmit,
}: VoteFormProps) {
  const [selectedOption, setSelectedOption] = useState<string>(currentOptionId ?? '')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (selectedOption) {
      onSubmit(selectedOption)
    }
  }

  const isUpdate = !!currentOptionId

  return (
    <Card>
      <CardHeader>
        <CardTitle>{question.statement}</CardTitle>
        <CardDescription>
          {isUpdate
            ? 'You have already voted. You can change your vote below.'
            : 'Select one of the options below and submit your vote.'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-6">
          <RadioGroup
            value={selectedOption}
            onValueChange={setSelectedOption}
            className="space-y-3"
          >
            {question.options.map((option) => (
              <div key={option.id} className="flex items-center space-x-3">
                <RadioGroupItem value={option.id} id={`option-${option.id}`} />
                <Label htmlFor={`option-${option.id}`} className="cursor-pointer text-base">
                  {option.text}
                </Label>
              </div>
            ))}
          </RadioGroup>
          <Button type="submit" disabled={!selectedOption || isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {isUpdate ? 'Update Vote' : 'Submit Vote'}
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}
